import { render, staticRenderFns } from "./CaseIVs.vue?vue&type=template&id=178bdec2&scoped=true&"
import script from "./CaseIVs.vue?vue&type=script&lang=js&"
export * from "./CaseIVs.vue?vue&type=script&lang=js&"
import style0 from "./CaseIVs.vue?vue&type=style&index=0&id=178bdec2&scoped=true&lang=css&"
import style1 from "./CaseIVs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178bdec2",
  null
  
)

export default component.exports